module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('page-head', {
    staticClass: "page-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.path.indexOf('oil_chart') === -1 && _vm.path.indexOf('gas_map') === -1) ? _c('left-bar-single') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('loading')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02143f62","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/oil/single_home.vue
// module id = 945
// module chunks = 1